import * as constants from './constants';
/**
 * Input selectors
 */ const mainSelector = (state)=>state[constants.MODULE_ID];
//----------------------------------------------------------------------------------------------------------------------
/**
 * Is menu open
 */ export const menuOpen = (state)=>mainSelector(state).menuOpen;
/**
 * Agp view mode
 */ export const agpView = (state)=>mainSelector(state).agpView;
/**
 * Selected menu item
 */ export const selectedMenuItem = (state)=>mainSelector(state).selectedMenuItem;
/**
 * Window width
 */ export const windowWidth = (state)=>mainSelector(state).windowWidth;
export const hideReadingsTable = (state)=>mainSelector(state).hideReadingsTable;
export const hideDailyDetails = (state)=>mainSelector(state).hideDailyDetails;
export const hideEmptyRows = (state)=>mainSelector(state).hideEmptyRows;
export const showDayDividers = (state)=>mainSelector(state).showDayDividers;
